// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zhgI","title":"styles_title__2i05r"};